import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Class } from '../data/class';
import { Student } from '../data/student';

@Component({
  selector: 'app-students-passcode',
  templateUrl: './students-passcode.component.html',
  styleUrls: ['./students-passcode.component.scss']
})
export class StudentsPasscodeComponent implements OnInit {
  @Input() class: Class;
  @Input() students: Student[];
  passcodeSize: string;
  studentsForddRender: Student[][];

  constructor() {
    this.passcodeSize = 'mini';
  }

  ngOnInit() {
    var tempArr;
    this.studentsForddRender = this.students.reduce((p, c, i) => {
      if (i % 3 == 0) {
        tempArr = new Array<Student>();
        p.push(tempArr)
      }
      tempArr.push(c);
      return p;
    }, new Array<Array<Student>>());
  }

  printDiv(divName) {
    const printContents = document.getElementById(divName).innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    window.location.reload();
  }
}
